import { render } from "./ServicesDetailsPage.vue?vue&type=template&id=6fd81f94"
import script from "./ServicesDetailsPage.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__